import preScaleWithBitmap from './preScaleWithBitmap';
import preScaleWithCanvas from './preScaleWithCanvas';

const PRE_SCALE_STRATEGIES = [
  {
    name: 'offscreen-bitmap',
    isSupported: () => {
      const globalObj =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : null;
      return (
        !!globalObj &&
        typeof globalObj.createImageBitmap !== 'undefined' &&
        typeof globalObj.OffscreenCanvas !== 'undefined' &&
        typeof globalObj.OffscreenCanvas.prototype.convertToBlob !== 'undefined'
      );
    },
    execute: preScaleWithBitmap,
  },
  {
    name: 'canvas-fallback',
    isSupported: () =>
      typeof globalThis !== 'undefined' &&
      typeof globalThis.document !== 'undefined',
    execute: preScaleWithCanvas,
  },
];

export const resolvePreScaleStrategy = () =>
  PRE_SCALE_STRATEGIES.find((strategy) => strategy.isSupported())?.execute ??
  null;
